<template>
    <div>
        <b-button @click="openEmployeeModal" variant="primary">
            ESS Activity Log
        </b-button>

        <b-modal
            id="select-employees-modal"
            title="Select Employee"
            size="xl"
            scrollable
            hide-footer
        >
            <b-overlay :show="showoverlay" rounded="sm">
                <div class="card">
                    <common-list
                        v-if="employees.length > 0"
                        :checkbox="checkbox"
                        :is_action="is_action"
                        :key="list_key"
                        :appended_column="appended_column"
                        :company_options="company_options"
                        :employees="employees"
                        :default_column="default_column"
                        :primary_key="primary_key"
                        :all_employee="all_employee"
                        v-on:childToParent="listReturn"
                    ></common-list>

                    <div v-else class="text-center py-4">
                        {{ blankmsg }}
                    </div>
                </div>
            </b-overlay>
        </b-modal>

        <b-modal
            id="ess-activity-log-modal"
            title="ESS Activity Log"
            size="xl"
            scrollable
            hide-footer
        >
            <ess-activity-index
                v-if="selected_employee_id > 0"
                :employee_id="selected_employee_id"
                :key="activity_log_key"
            ></ess-activity-index>
        </b-modal>
    </div>
</template>

<script>

export default {
    props: ['flg'],

    components: {
    },

    data() {
        return {
            all_employee: 'yes',

            checkbox: 0,
            is_action: 0,
            list_key: 0,
            employees: [],
            default_column: ['name', 'phone', 'email', 'jobposition', 'department', 'branch'],
            primary_key: 'employee_id',
            company_options: [],
            appended_column: [],

            notice: 'No Result Found!',
            blankmsg: 'Fetching data..',

            showoverlay: false,

            selected: [],
            selected_employee_id: 0,
            activity_log_key: 0
        };
    },

    methods: {
        openEmployeeModal() {
            this.$bvModal.show('select-employees-modal');

            if (this.employees.length === 0) {
                this.getEmployees();
            }
        },

        getEmployees() {
            if (!this.checkNet()) {
                return false;
            }

            this.showoverlay = true;
            this.blankmsg = 'Fetching data..';

            axios.get(this.$api_url + '/employee/list')
                .then(function (response) {
                    if (response.data.error == 1) {
                        this.notice = response.data.notice;
                        this.blankmsg = response.data.notice || 'No Result Found!';
                        this.employees = [];
                    } else {
                        this.employees = response.data.employee_data || [];
                        this.company_options = response.data.options || [];
                        this.blankmsg = this.employees.length > 0 ? '' : 'No Result Found!';
                        this.list_key = this.list_key + 1;
                    }
                }.bind(this))
                .catch(function (error) {
                    this.employees = [];
                    this.blankmsg = 'Failed to load employee list.';
                    this.serverError(error);
                }.bind(this))
                .finally(function () {
                    this.showoverlay = false;
                }.bind(this));
        },

        listReturn(data) {
            if (data.selected && data.selected.length > 0) {
                this.selected = data.selected;
                return;
            }

            this.selected = [];

            if (data.employee_id > 0) {
                this.openActivityLog(data.employee_id);
            }
        },

        openActivityLog(employeeId) {
            this.selected_employee_id = employeeId;

            let currentObj = this;
            let formData = new FormData();
            formData.append('employee_id', employeeId);
            axios.post(this.$api_url+'/employee/setemployee', formData)
            .then(function (response)
            {
                this.activity_log_key = this.activity_log_key + 1;

                this.$bvModal.hide('select-employees-modal');
                this.$bvModal.show('ess-activity-log-modal');

            }.bind(this))
            .catch(function (error)
            {
                currentObj.showoverlay = false;
                currentObj.serverError(error);
            });

        }
    }
};
</script>